export const WindowSizeBreakpoints = {
    SMALL: 768,
    MEDIUM: 992,
    LARGE: 1200,
};

export const DesktopLazyLoadOffset = 400;
export const MobileLazyLoadOffset = 10;



// WEBPACK FOOTER //
// ./assets/js/components/Consts.ts